import type { CSSProperties } from 'react';
import { cn } from '@/lib/cn';
import type { OddsFlash } from './OddsButton';

export function oddsFlashOverlayStyle(flash: Exclude<OddsFlash, 'none'>): CSSProperties {
  const statusColor =
    flash === 'up' ? 'var(--color-status-success)' : 'var(--color-status-danger)';

  return {
    borderRadius: 'var(--radius-sm)',
    background: `radial-gradient(50% 50% at 50% 50%, ${statusColor} 0%, rgba(102, 102, 102, 0.30) 100%)`,
  };
}

export function OddsFlashOverlay({
  flash,
  className,
}: {
  flash: Exclude<OddsFlash, 'none'>;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn('pointer-events-none absolute inset-0 animate-odds-flash', className)}
      style={oddsFlashOverlayStyle(flash)}
    />
  );
}
